import IconButton from "@mui/material/IconButton";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useThemeMode } from "./ThemeModeProvider";

export function ThemeToggleButton() {
    const { mode, toggle } = useThemeMode();

    return (
        <IconButton onClick={toggle} aria-label="toggle theme" color="inherit">
            {mode === "dark" ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
    );
}
